export var InputRole;
(function (InputRole) {
    InputRole["USER"] = "user";
    InputRole["ASSISTANT"] = "assistant";
    InputRole["SYSTEM"] = "system";
    InputRole["DEVELOPER"] = "developer";
})(InputRole || (InputRole = {}));
